module.exports = __webpack_public_path__ + "img/DK39966263.67206e4f.png";